import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, unref as _unref, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "modal-calificar-unificado" }
const _hoisted_2 = { class: "modal-header-section" }
const _hoisted_3 = {
  key: 0,
  class: "ctx-strip"
}
const _hoisted_4 = {
  key: 0,
  class: "ctx-version"
}
const _hoisted_5 = {
  key: 0,
  class: "ctx-ruta-tipo"
}
const _hoisted_6 = {
  key: 1,
  class: "ctx-ruta-ordinal"
}
const _hoisted_7 = { class: "ctx-ruta-nombre" }
const _hoisted_8 = {
  key: 2,
  class: "ctx-ruta-nodo ctx-indicador-row"
}
const _hoisted_9 = { class: "ctx-indicador" }
const _hoisted_10 = {
  key: 0,
  class: "info"
}
const _hoisted_11 = {
  key: 1,
  class: "seccion-colapsable"
}
const _hoisted_12 = { class: "toggle-icon" }
const _hoisted_13 = {
  key: 0,
  class: "rubrica-contenido"
}
const _hoisted_14 = { class: "rubrica-header" }
const _hoisted_15 = { class: "badge-tipo" }
const _hoisted_16 = { class: "rubrica-sub" }
const _hoisted_17 = {
  key: 1,
  class: "sin-rubrica-msg"
}
const _hoisted_18 = { class: "seccion-colapsable" }
const _hoisted_19 = { class: "toggle-icon" }
const _hoisted_20 = {
  key: 0,
  class: "instrumento-contenido"
}
const _hoisted_21 = { class: "info-grid" }
const _hoisted_22 = { class: "info-item" }
const _hoisted_23 = { class: "info-value" }
const _hoisted_24 = { class: "info-item" }
const _hoisted_25 = { class: "info-value" }
const _hoisted_26 = { class: "info-item" }
const _hoisted_27 = { class: "info-value" }
const _hoisted_28 = {
  key: 0,
  class: "info-item"
}
const _hoisted_29 = { class: "info-value" }
const _hoisted_30 = {
  key: 0,
  class: "fichas-vinculadas"
}
const _hoisted_31 = { class: "fo-pregunta-cab" }
const _hoisted_32 = { class: "fo-enunciado" }
const _hoisted_33 = {
  key: 0,
  class: "fo-nota fo-nota--calculada"
}
const _hoisted_34 = {
  key: 1,
  class: "fo-nota"
}
const _hoisted_35 = {
  key: 2,
  class: "fo-nota fo-nota--vacia"
}
const _hoisted_36 = { class: "fo-pregunta-meta" }
const _hoisted_37 = { key: 0 }
const _hoisted_38 = {
  key: 1,
  class: "fo-origen"
}
const _hoisted_39 = {
  key: 2,
  class: "fo-pct-cumpl"
}
const _hoisted_40 = {
  key: 0,
  class: "fo-dist"
}
const _hoisted_41 = { class: "fo-opcion" }
const _hoisted_42 = { class: "fo-barra" }
const _hoisted_43 = { class: "fo-pct" }
const _hoisted_44 = {
  key: 1,
  class: "fo-sin-respuestas"
}
const _hoisted_45 = {
  key: 1,
  class: "sin-fichas"
}
const _hoisted_46 = {
  key: 1,
  class: "fichas-vinculadas"
}
const _hoisted_47 = {
  key: 0,
  class: "fichas-lista"
}
const _hoisted_48 = { class: "ficha-card-header" }
const _hoisted_49 = { class: "ficha-tipo" }
const _hoisted_50 = { class: "ficha-card-body" }
const _hoisted_51 = {
  key: 0,
  class: "ficha-detalle"
}
const _hoisted_52 = {
  key: 1,
  class: "ficha-detalle sin-detalle"
}
const _hoisted_53 = {
  key: 2,
  class: "ficha-descripcion"
}
const _hoisted_54 = {
  key: 3,
  class: "ficha-observaciones"
}
const _hoisted_55 = ["href"]
const _hoisted_56 = ["href", "title"]
const _hoisted_57 = {
  key: 1,
  class: "badge-origen externo"
}
const _hoisted_58 = {
  key: 2,
  class: "badge-formato"
}
const _hoisted_59 = {
  key: 5,
  class: "badge-origen desconocido"
}
const _hoisted_60 = ["href"]
const _hoisted_61 = {
  key: 7,
  class: "ficha-documento-badge sin-doc"
}
const _hoisted_62 = {
  key: 0,
  class: "ficha-calculo"
}
const _hoisted_63 = { class: "fc-cab" }
const _hoisted_64 = { class: "fc-titulo" }
const _hoisted_65 = { class: "fc-nota" }
const _hoisted_66 = ["onClick"]
const _hoisted_67 = {
  key: 0,
  class: "fc-sin"
}
const _hoisted_68 = { class: "fc-resumen" }
const _hoisted_69 = {
  key: 0,
  class: "fc-tabla"
}
const _hoisted_70 = { key: 0 }
const _hoisted_71 = { colspan: "2" }
const _hoisted_72 = {
  key: 1,
  class: "fc-aviso"
}
const _hoisted_73 = {
  key: 2,
  class: "fc-aviso"
}
const _hoisted_74 = {
  key: 1,
  class: "sin-fichas"
}
const _hoisted_75 = {
  key: 1,
  class: "sin-instrumento-msg"
}
const _hoisted_76 = { class: "fila" }
const _hoisted_77 = ["min", "max", "placeholder"]
const _hoisted_78 = {
  key: 0,
  class: "nota-desde-ficha"
}
const _hoisted_79 = { class: "grado-texto" }
const _hoisted_80 = {
  key: 2,
  class: "sin-nivel-detectado"
}
const _hoisted_81 = { class: "fila" }
const _hoisted_82 = { class: "fila" }
const _hoisted_83 = { class: "fila" }
const _hoisted_84 = ["max"]
const _hoisted_85 = { class: "botones" }
const _hoisted_86 = ["disabled"]

import { ref, computed, onMounted } from 'vue'
import { useGestionEvaluacionesIndicadores } from '@/store/GestionEvaluacionesIndicadores'
import { useGestionInstrumento } from '@/store/GestionInstrumentos'
import { useGestionIndicadorInstrumentos } from '@/store/GestionIndicadorInstrumentos'
import { useGestionFichas } from '@/store/GestionFichas'
import { useGestionCriterioEvaluacion } from '@/store/GestionCriterioEvaluacion'
import { useGestionTipoComponente } from '@/store/GestionTipoComponente'
import { useGestionIndicadores } from '@/store/GestionIndicadores'
import { useGestionUsuarios } from '@/store/GestionUsuario'
import { useGestionVersiones } from '@/store/GestionVersiones'
import { useComponentes } from '@/store/GestionComponentes'
import type Componente from '@/interfaces/Componente'
import { listarConfiguracionesService, obtenerConfiguracionService } from '@/services/ConfiguracionInstrumentoService'
import { getVistaCalificacionService, type PreguntaCalificable, type DistribucionRespuesta } from '@/services/CalificacionOpinionPreguntaService'
import type Instrumento from '@/interfaces/Instrumetos'
import type { CriterioEvaluacion } from '@/interfaces/CriterioEvaluacion'
import MensajeFlotante from '@/components/MensajeFlotante.vue'
import RubricaTabla from '@/components/RubricaTabla.vue'
import { derivarGrado } from '@/utils/consolidacion'

interface RutaNodo { tipo: string; ordinal: string; nombre: string }

interface FilaRubrica { clave: string; titulo: string; rango: string; descripcion: string; rango_min: number; rango_max: number }


export default /*@__PURE__*/_defineComponent({
  __name: 'CalificarIndicadorUnificadoModal',
  props: {
    idVersion: {},
    idIndicador: {},
    idEjecucion: {},
    escalaMax: {}
  },
  emits: ["cerrar"],
  setup(__props: any, { emit: __emit }) {

/**
 * Calificación de un indicador en sus tres dimensiones.
 *
 * Una dimensión que no aplica se deja VACÍA, no en cero: la nota final se
 * repondera sobre las dimensiones presentes.
 *
 * Componente de presentación. Recibe sus datos por props o del store del módulo.
 */

const props = __props

const emit = __emit

const store = useGestionEvaluacionesIndicadores()
const instrumentosStore = useGestionInstrumento()
const indicadorInstrumentoStore = useGestionIndicadorInstrumentos()
const fichasStore = useGestionFichas()
const criteriosStore = useGestionCriterioEvaluacion()
const tiposStore = useGestionTipoComponente()
const indicadoresStore = useGestionIndicadores()
const usuariosStore = useGestionUsuarios()
const versionesStore = useGestionVersiones()
const componentesStore = useComponentes()

const nombreVersion = computed(() =>
  versionesStore.versiones.find(v => v.id_version === props.idVersion)?.nombre
  ?? versionesStore.versionActual?.nombre
  ?? ''
)

function formatOrdinal(ordinal: string): string {
  if (!ordinal) return ''
  const parts = ordinal.split('.')
  return parts.length > 1 ? parts.slice(1).join('.') : ordinal
}

function buildRutaComponente(idComponente: number): RutaNodo[] {
  type NodoTemp = { idTipo: number | null | undefined; ordinal: string; nombre: string }
  const path: NodoTemp[] = []
  function buscar(nodos: Componente[], target: number, padres: NodoTemp[]): boolean {
    for (const n of nodos) {
      const nodoTemp: NodoTemp = { idTipo: n.id_tipo_componente, ordinal: formatOrdinal(n.ordinal ?? ''), nombre: n.nombre }
      if (n.id_componente === target) {
        padres.forEach(p => path.push(p))
        path.push(nodoTemp)
        return true
      }
      if ((n as any).children?.length && buscar((n as any).children, target, [...padres, nodoTemp])) return true
    }
    return false
  }
  const raiz = componentesStore.componentes[0]
  if (raiz && (raiz as any).children) buscar((raiz as any).children, idComponente, [])
  return path.map(p => ({
    tipo: tiposStore.tipos.find(t => t.id_tipo_componente === p.idTipo)?.nombre ?? '',
    ordinal: p.ordinal,
    nombre: p.nombre
  }))
}

const rutaComponente = computed<RutaNodo[]>(() => {
  const idComp = indicadorActual.value?.id_componente
  return idComp ? buildRutaComponente(idComp) : []
})
const mensajeVisible = ref(false)
const mensajeTexto = ref('')
const mensajeTipo = ref<'positivo' | 'error'>('positivo')

function mostrarMensaje(texto: string, tipo: 'positivo' | 'error') {
  mensajeTexto.value = texto
  mensajeTipo.value = tipo
  mensajeVisible.value = true
}

const loading = ref(false)
const guardando = ref(false)
const esEdicion = ref(false)
const evaluacionId = ref<number | null>(null)
const instrumentosVinculados = ref<Instrumento[]>([])
const fichasPorInstrumento = ref<Record<number, any[]>>({})
/** Preguntas del indicador actual extraídas de las vistas de calificación de opinión, por instrumento. */
const preguntasOpinionPorInstrumento = ref<Record<number, PreguntaCalificable[]>>({})
/** Todas las opciones definidas en el snapshot para cada pregunta (incluye las con 0 respuestas). */
const opcionesPorPregunta = ref<Record<number, string[]>>({})
const rubricasVisible = ref(true)
const instrumentosVisible = ref(false)
const notaFinal = ref<number | null>(null)

const hoy = new Date().toISOString().split('T')[0]

const form = ref({
  observaciones: '',
  justificacion: '',
  fecha_evaluacion: hoy
})

const indicadorActual = computed(() => indicadoresStore.indicadorActual)

const escala = computed(() => props.escalaMax ?? 5)
const escalaMin = computed(() => escala.value > 5 ? 1 : 0)

function clampNotaFinal() {
  if (notaFinal.value === null) return
  if (notaFinal.value < escalaMin.value) notaFinal.value = escalaMin.value
  else if (notaFinal.value > escala.value) notaFinal.value = escala.value
}

const colorSemaforo = computed(() => {
  if (notaFinal.value === null) return ''
  const n = notaFinal.value
  if (escala.value === 10) {
    if (n < 4.7) return 'semaforo-rojo'
    if (n < 6.5) return 'semaforo-amarillo'
    return 'semaforo-verde'
  }
  if (n < 3) return 'semaforo-rojo'
  if (n < 4) return 'semaforo-amarillo'
  return 'semaforo-verde'
})

function filasDeRubrica(ce: any): FilaRubrica[] {
  const r = ce?.criterio
  if (!r) return []
  if (Array.isArray(r.niveles)) {
    return r.niveles.map((n: any, i: number) => ({
      clave: n.codigo ?? n.grado ?? `n${i}`,
      titulo: n.label ?? n.grado ?? `Nivel ${i + 1}`,
      rango: `${n.rango_min} – ${n.rango_max}`,
      descripcion: n.descripcion ?? n.tendencia ?? '',
      rango_min: n.rango_min,
      rango_max: n.rango_max
    }))
  }
  if (Array.isArray(r.grados)) {
    return r.grados.map((g: any, i: number) => ({
      clave: g.grado ?? `g${i}`,
      titulo: g.grado ?? `Grado ${i + 1}`,
      rango: `${g.rango_min} – ${g.rango_max}`,
      descripcion: Object.entries(g.descriptores ?? {}).map(([c, d]) => `${c}: ${d}`).join(' · '),
      rango_min: g.rango_min,
      rango_max: g.rango_max
    }))
  }
  return []
}

/** R\u00f3tulo de la ficha a la que pertenece la r\u00fabrica, como en el visor. */
function subtituloRubrica(ce: any): string {
  switch (ce?.tipo_informacion) {
    case 'documental': return 'Ficha de revisi\u00f3n documental'
    case 'cuantitativa': return 'Ficha de revisi\u00f3n de indicadores estad\u00edsticos'
    case 'opinion': return 'Tabla de valoraci\u00f3n'
    default: return ''
  }
}

const gradoDetectado = computed(() => {
  if (notaFinal.value === null) return null
  const nota = notaFinal.value
  for (const criterio of criteriosEvaluacion.value) {
    const fila = filasDeRubrica(criterio).find(f => nota >= f.rango_min && nota <= f.rango_max)
    if (fila) {
      return { label: fila.titulo, descripcion: fila.descripcion, rango: fila.rango, codigo: fila.clave }
    }
  }
  const grado = derivarGrado(nota, escala.value as 5 | 10)
  if (grado) {
    return {
      label: grado.nombre,
      descripcion: escala.value === 10 ? 'Escala 1-10' : 'Catálogo canónico MAAM',
      rango: `${grado.rango_min}-${grado.rango_max}`,
      codigo: grado.nombre
    }
  }
  return null
})

function tipoNombrePorInstrumento(instrumento: Instrumento): string {
  const tipo = tiposStore.tipos.find(t => t.id_tipo_componente === instrumento.id_tipo_componente)
  return tipo?.nombre ?? `Tipo #${instrumento.id_tipo_componente}`
}

function estadoClass(estado?: string): string {
  if (!estado) return ''
  const e = estado.toLowerCase()
  if (e === 'existente' || e === 'existe') return 'estado-existente'
  if (e === 'actualizado' || e === 'actualizable') return 'estado-actualizado'
  if (e === 'no_existe') return 'estado-no-existe'
  return ''
}

function estadoTexto(estado?: string): string {
  if (!estado) return 'Sin estado'
  const e = estado.toLowerCase()
  if (e === 'existente' || e === 'existe') return '🟢 Existente'
  if (e === 'actualizado' || e === 'actualizable') return '🟡 Actualizado'
  if (e === 'no_existe') return '🔴 No existe'
  return estado
}

function parseCriterio(ce: CriterioEvaluacion): CriterioEvaluacion {
  if (typeof ce.criterio === 'string') {
    try {
      ce.criterio = JSON.parse(ce.criterio as unknown as string)
    } catch {
      ce.criterio = { niveles: [] }
    }
  }
  if (!ce.criterio) {
    ce.criterio = { niveles: [] }
  }
  return ce
}

function tipoInformacionDeInstrumento(instrumento: Instrumento): string | null {
  const tipo = tiposStore.tipos.find(t => t.id_tipo_componente === instrumento.id_tipo_componente)
  if (!tipo?.nombre) return null
  const n = tipo.nombre.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim()
  if (n.includes('documental') || n.includes('documento')) return 'documental'
  if (n.includes('cuantitativ') || n.includes('estadistic')) return 'cuantitativa'
  if (n.includes('opinion') || n.includes('encuesta')) return 'opinion'
  return n
}

function distribucionCompleta(p: PreguntaCalificable): DistribucionRespuesta[] {
  const dist = p.respuestas.distribucion
  const todasOpciones = opcionesPorPregunta.value[p.id_pregunta]
  if (todasOpciones?.length) {
    const existentes = new Map(dist.map(d => [d.opcion, d]))
    return todasOpciones.map(op => existentes.get(op) ?? { opcion: op, cantidad: 0, porcentaje: 0 })
  }
  if (!dist.length) return dist
  const sonNumericos = dist.every(d => d.opcion.trim() !== '' && !isNaN(Number(d.opcion)))
  if (!sonNumericos) return dist
  const existentesNum = new Map(dist.map(d => [Number(d.opcion), d]))
  const resultado: DistribucionRespuesta[] = []
  for (let i = escalaMin.value; i <= escala.value; i++) {
    resultado.push(existentesNum.get(i) ?? { opcion: String(i), cantidad: 0, porcentaje: 0 })
  }
  return resultado
}

// Criterios de evaluación: combinar de todos los instrumentos (sin duplicados)
const criteriosEvaluacion = computed(() => {
  const todos = criteriosStore.criteriosEvaluacion.map(parseCriterio)
  if (!todos.length) return []

  if (!instrumentosVinculados.value.length) return []

  const resultado: CriterioEvaluacion[] = []
  for (const instrumento of instrumentosVinculados.value) {
    const porId = todos.filter(c => c.id_tipo_componente === instrumento.id_tipo_componente)
    for (const c of porId) {
      if (!resultado.find(r => r.id === c.id)) resultado.push(c)
    }
    if (!porId.length) {
      const tipoInfo = tipoInformacionDeInstrumento(instrumento)
      if (tipoInfo) {
        const porTipoInfo = todos.filter(c => c.tipo_informacion === tipoInfo)
        for (const c of porTipoInfo) {
          if (!resultado.find(r => r.id === c.id)) resultado.push(c)
        }
      }
    }
  }
  return resultado
})

// CARGA Y GUARDADO DE EVALUACIÓN
function buildCalificaciones(nota: number): {
  calificacion_documental?: number
  calificacion_cuantitativa?: number
  calificacion_opinion?: number
} {
  if (!instrumentosVinculados.value.length) {
    return { calificacion_documental: nota, calificacion_cuantitativa: nota, calificacion_opinion: nota }
  }
  const tipos = new Set(
    instrumentosVinculados.value.map(tipoInformacionDeInstrumento).filter(Boolean)
  )
  const campos: Record<string, number> = {}
  if (tipos.has('documental')) campos.calificacion_documental = nota
  if (tipos.has('cuantitativa')) campos.calificacion_cuantitativa = nota
  if (tipos.has('opinion')) campos.calificacion_opinion = nota
  if (!Object.keys(campos).length) {
    return { calificacion_documental: nota, calificacion_cuantitativa: nota, calificacion_opinion: nota }
  }
  return campos
}

/**
 * Adopta la nota que calculó la ficha cuantitativa.
 *
 * El calificador no tiene por qué transcribirla a mano —transcribir es
 * justamente donde se cuela el error—, y como la ficha guarda su propia nota,
 * queda el rastro de sobre qué cálculo se calificó aunque después cambie.
 */
function usarNotaDeFicha(ficha: any) {
  const nota = ficha?.calculo?.nota
  if (nota == null) return
  notaFinal.value = Number(nota)
  notaVieneDeLaFicha.value = true
  clampNotaFinal()
}

/** Marca que la nota del campo la puso el cálculo, no el calificador. */
const notaVieneDeLaFicha = ref(false)

/**
 * Nota calculada por las fichas cuantitativas de este indicador, si hay una
 * sola. Con varias no se elige por el calificador: cuál manda es decisión suya.
 */
const notaCuantitativaSugerida = computed<number | null>(() => {
  const notas = Object.values(fichasPorInstrumento.value)
    .flat()
    .map((f: any) => f?.calculo?.nota)
    .filter((n): n is number => n != null)
  return notas.length === 1 ? notas[0] : null
})

async function cargarEvaluacionExistente() {
  await store.cargar({ id_version: props.idVersion, id_indicador: props.idIndicador })
  const existente = props.idEjecucion
    ? store.evaluaciones.find(e => e.id_ejecucion === props.idEjecucion)
    : (store.evaluaciones.find(e => e.id_ejecucion == null) ?? store.evaluaciones[0])
  if (existente) {
    esEdicion.value = true
    evaluacionId.value = existente.id ?? null
    notaFinal.value = existente.calificacion_final ?? null
    form.value.observaciones = existente.observaciones ?? ''
    form.value.justificacion = existente.justificacion ?? ''
    form.value.fecha_evaluacion = existente.fecha_evaluacion ?? hoy
  }
}

async function guardarEvaluacion() {
  if (notaFinal.value === null || notaFinal.value === undefined) {
    mostrarMensaje('Ingrese la nota final.', 'error')
    return
  }

  if (notaFinal.value < escalaMin.value || notaFinal.value > escala.value) {
    mostrarMensaje(`La nota debe estar entre ${escalaMin.value} y ${escala.value}.`, 'error')
    return
  }

  if (!form.value.fecha_evaluacion) {
    mostrarMensaje('La fecha de evaluación es obligatoria.', 'error')
    return
  }

  const usuario = usuariosStore.usuarioActual ?? await usuariosStore.me()
  if (!usuario?.id) {
    mostrarMensaje('No se pudo identificar al usuario.', 'error')
    return
  }

  const calificaciones = buildCalificaciones(notaFinal.value)

  guardando.value = true
  try {
    if (esEdicion.value && evaluacionId.value) {
      const result = await store.actualizar(evaluacionId.value, {
        ...calificaciones,
        observaciones: form.value.observaciones || undefined,
        justificacion: form.value.justificacion || undefined,
        id_usuario_editor: usuario.id
      })
      if (result.ok) {
        mostrarMensaje('Evaluación actualizada correctamente.', 'positivo')
        emit('cerrar')
      } else {
        mostrarMensaje('No se pudo actualizar la evaluación. Intente de nuevo.', 'error')
      }
    } else {
      const result = await store.crearOActualizar({
        id_version: props.idVersion,
        id_indicador: props.idIndicador,
        id_ejecucion: props.idEjecucion ?? null,
        id_usuario: usuario.id,
        ...calificaciones,
        observaciones: form.value.observaciones || null,
        justificacion: form.value.justificacion || null,
        fecha_evaluacion: form.value.fecha_evaluacion
      })
      if (result.ok) {
        mostrarMensaje('Evaluación registrada correctamente.', 'positivo')
        esEdicion.value = true
        if (result.data?.id) evaluacionId.value = result.data.id
        emit('cerrar')
      } else {
        mostrarMensaje('No se pudo guardar la evaluación. Intente de nuevo.', 'error')
      }
    }
  } finally {
    guardando.value = false
  }
}

onMounted(async () => {
  loading.value = true
  try {
    // Fase 1: carga base en paralelo — indicador específico, criterios, tipos, relaciones y evaluación
    await Promise.all([
      indicadoresStore.cargarPorId(props.idIndicador),
      criteriosStore.cargarTodos(),
      tiposStore.getTipos(),
      indicadorInstrumentoStore.getRelaciones(),
      Number.isFinite(props.idVersion) && Number.isFinite(props.idIndicador)
        ? cargarEvaluacionExistente()
        : Promise.resolve()
    ])

    // Fase 2: cargar solo los instrumentos vinculados a este indicador en paralelo
    const relaciones = indicadorInstrumentoStore.relaciones.filter(
      r => Number(r.id_indicador) === Number(props.idIndicador)
    )
    const instrumentosData = await Promise.all(
      relaciones.map(r => instrumentosStore.getInstrumentoById(r.id_instrumento))
    )
    instrumentosVinculados.value = instrumentosData.filter((i): i is Instrumento => !!i)

    // Fase 3: fichas de evidencia (documental/cuantitativa) por instrumento
    const fichasEntries = await Promise.all(
      instrumentosVinculados.value
        .filter(i => i.id_instrumento != null)
        .map(async instr => {
          const fichas = await fichasStore.listarFichas({ id_instrumento: instr.id_instrumento! })
          const vistas = new Set<number>()
          const unicas = (fichas ?? []).filter((f: any) => {
            if (!f.id_ficha || vistas.has(f.id_ficha)) return false
            vistas.add(f.id_ficha)
            return true
          })
          return [instr.id_instrumento!, unicas] as [number, any[]]
        })
    )
    fichasPorInstrumento.value = Object.fromEntries(fichasEntries)

    // Fase 4: para instrumentos de opinión, obtener las preguntas vinculadas a
    // este indicador usando getVistaCalificacionService (igual que CalificarInstrumentoOpinionView).
    const opinionInstrs = instrumentosVinculados.value.filter(
      i => tipoInformacionDeInstrumento(i) === 'opinion' && i.id_instrumento != null
    )
    const preguntasEntries = await Promise.all(
      opinionInstrs.map(async (instr) => {
        const preguntas: PreguntaCalificable[] = []
        try {
          const configs = await listarConfiguracionesService({ id_instrumento: instr.id_instrumento! })
          for (const cfg of configs) {
            const [vista, configResult] = await Promise.all([
              getVistaCalificacionService(cfg.id_configuracion, props.idEjecucion),
              obtenerConfiguracionService(cfg.id_configuracion)
            ])
            if (configResult.ok && configResult.data) {
              for (const formulario of configResult.data.formularios ?? []) {
                for (const snap of formulario.preguntas_snapshot ?? []) {
                  if (snap.opciones?.length) opcionesPorPregunta.value[snap.id_pregunta] = snap.opciones
                }
              }
            }
            if (!vista) continue
            for (const aspecto of vista.aspectos) {
              for (const ind of aspecto.indicadores) {
                if (Number(ind.id_indicador) === Number(props.idIndicador)) {
                  preguntas.push(...ind.preguntas)
                }
              }
            }
          }
        } catch { /* noop */ }
        return [instr.id_instrumento!, preguntas] as [number, PreguntaCalificable[]]
      })
    )
    preguntasOpinionPorInstrumento.value = Object.fromEntries(preguntasEntries)

    // Si el indicador aún no se ha calificado y sus fichas ya traen una nota
    // calculada, se propone: el calificador la ve puesta y decide si la deja o
    // la mejora, en vez de tener que copiarla a mano.
    if (notaFinal.value === null && notaCuantitativaSugerida.value !== null) {
      notaFinal.value = notaCuantitativaSugerida.value
      notaVieneDeLaFicha.value = true
      clampNotaFinal()
    }
  } catch {
    mostrarMensaje('Error al cargar los datos. Intente de nuevo.', 'error')
  } finally {
    loading.value = false
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[10] || (_cache[10] = _createElementVNode("h1", null, "Evaluación del Indicador", -1)),
      (nombreVersion.value || rutaComponente.value.length || indicadorActual.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            (nombreVersion.value)
              ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(nombreVersion.value), 1))
              : _createCommentVNode("", true),
            (rutaComponente.value.length)
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(rutaComponente.value, (nodo, i) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: i,
                    class: "ctx-ruta-nodo"
                  }, [
                    (nodo.tipo)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(nodo.tipo), 1))
                      : _createCommentVNode("", true),
                    (nodo.ordinal)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(nodo.ordinal), 1))
                      : _createCommentVNode("", true),
                    _createElementVNode("span", _hoisted_7, _toDisplayString(nodo.nombre), 1)
                  ]))
                }), 128))
              : _createCommentVNode("", true),
            (indicadorActual.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _cache[9] || (_cache[9] = _createElementVNode("span", { class: "ctx-ruta-tipo" }, "Indicador", -1)),
                  _createElementVNode("span", _hoisted_9, _toDisplayString(indicadorActual.value.enunciado ?? indicadorActual.value.nombre), 1)
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ]),
    (loading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, "Cargando evaluacion..."))
      : _createCommentVNode("", true),
    (!loading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
          _createElementVNode("button", {
            type: "button",
            class: "toggle-btn",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (rubricasVisible.value = !rubricasVisible.value))
          }, [
            _cache[11] || (_cache[11] = _createElementVNode("span", null, "Rúbrica de Evaluación", -1)),
            _createElementVNode("span", _hoisted_12, _toDisplayString(rubricasVisible.value ? '▲' : '▼'), 1)
          ]),
          (rubricasVisible.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                (criteriosEvaluacion.value.length)
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(criteriosEvaluacion.value, (criterio) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: criterio.id ?? criterio.tipo_informacion,
                        class: "rubrica-bloque"
                      }, [
                        _createElementVNode("div", _hoisted_14, [
                          _createElementVNode("span", _hoisted_15, _toDisplayString(criterio.tipo_informacion), 1),
                          _createElementVNode("span", _hoisted_16, _toDisplayString(subtituloRubrica(criterio)), 1)
                        ]),
                        _createVNode(RubricaTabla, {
                          rubrica: criterio.criterio,
                          notaActual: notaFinal.value
                        }, null, 8, ["rubrica", "notaActual"])
                      ]))
                    }), 128))
                  : (_openBlock(), _createElementBlock("div", _hoisted_17, _cache[12] || (_cache[12] = [
                      _createElementVNode("p", null, "No hay rúbricas disponibles para este indicador.", -1)
                    ])))
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _cache[27] || (_cache[27] = _createElementVNode("div", { class: "divider" }, null, -1)),
    _createElementVNode("div", _hoisted_18, [
      _createElementVNode("button", {
        type: "button",
        class: "toggle-btn",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (instrumentosVisible.value = !instrumentosVisible.value))
      }, [
        _createElementVNode("span", null, "Instrumento" + _toDisplayString(instrumentosVinculados.value.length > 1 ? 's' : ''), 1),
        _createElementVNode("span", _hoisted_19, _toDisplayString(instrumentosVisible.value ? '▲' : '▼'), 1)
      ]),
      (instrumentosVisible.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
            (instrumentosVinculados.value.length)
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(instrumentosVinculados.value, (instrumento) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: instrumento.id_instrumento,
                    class: "instrumento-bloque"
                  }, [
                    _createElementVNode("div", _hoisted_21, [
                      _createElementVNode("div", _hoisted_22, [
                        _cache[13] || (_cache[13] = _createElementVNode("span", { class: "info-label" }, "Herramienta", -1)),
                        _createElementVNode("span", _hoisted_23, _toDisplayString(instrumento.herramienta), 1)
                      ]),
                      _createElementVNode("div", _hoisted_24, [
                        _cache[14] || (_cache[14] = _createElementVNode("span", { class: "info-label" }, "Descripción", -1)),
                        _createElementVNode("span", _hoisted_25, _toDisplayString(instrumento.descripcion || '—'), 1)
                      ]),
                      _createElementVNode("div", _hoisted_26, [
                        _cache[15] || (_cache[15] = _createElementVNode("span", { class: "info-label" }, "Tipo", -1)),
                        _createElementVNode("span", _hoisted_27, _toDisplayString(tipoNombrePorInstrumento(instrumento)), 1)
                      ]),
                      (instrumento.grupos_interes?.length)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                            _cache[16] || (_cache[16] = _createElementVNode("span", { class: "info-label" }, "Grupos de interés", -1)),
                            _createElementVNode("span", _hoisted_29, _toDisplayString(instrumento.grupos_interes.map((g) => g.nombre ?? g).join(', ')), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    (tipoInformacionDeInstrumento(instrumento) === 'opinion')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                          _cache[17] || (_cache[17] = _createElementVNode("h4", null, "Preguntas de opinión vinculadas a este indicador", -1)),
                          ((preguntasOpinionPorInstrumento.value[instrumento.id_instrumento!] ?? []).length)
                            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(preguntasOpinionPorInstrumento.value[instrumento.id_instrumento!], (p) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: p.id_pregunta,
                                  class: "fo-pregunta"
                                }, [
                                  _createElementVNode("div", _hoisted_31, [
                                    _createElementVNode("span", _hoisted_32, _toDisplayString(p.enunciado), 1),
                                    (p.nota_sugerida?.nota != null)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_33, _toDisplayString(p.nota_sugerida.nota.toFixed(2)), 1))
                                      : (p.respuestas.promedio !== null)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_34, _toDisplayString(p.respuestas.promedio), 1))
                                        : (_openBlock(), _createElementBlock("span", _hoisted_35, "sin nota"))
                                  ]),
                                  _createElementVNode("div", _hoisted_36, [
                                    (p.grupo_interes)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_37, _toDisplayString(p.grupo_interes), 1))
                                      : _createCommentVNode("", true),
                                    (p.formulario?.titulo)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_38, _toDisplayString(p.formulario.titulo), 1))
                                      : _createCommentVNode("", true),
                                    _createElementVNode("span", null, _toDisplayString(p.respuestas.total) + " respuesta" + _toDisplayString(p.respuestas.total === 1 ? '' : 's'), 1),
                                    (p.nota_sugerida?.desglose)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_39, _toDisplayString(p.nota_sugerida.desglose.porcentaje_cumplimiento.toFixed(2)) + "% de cumplimiento ", 1))
                                      : _createCommentVNode("", true)
                                  ]),
                                  (distribucionCompleta(p).length)
                                    ? (_openBlock(), _createElementBlock("ul", _hoisted_40, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(distribucionCompleta(p), (d) => {
                                          return (_openBlock(), _createElementBlock("li", {
                                            key: d.opcion,
                                            class: _normalizeClass(['fo-dist-fila', d.cantidad === 0 ? 'fo-dist-fila--vacia' : ''])
                                          }, [
                                            _createElementVNode("span", _hoisted_41, _toDisplayString(d.opcion), 1),
                                            _createElementVNode("span", _hoisted_42, [
                                              _createElementVNode("span", {
                                                class: "fo-barra-relleno",
                                                style: _normalizeStyle({ width: `${d.porcentaje}%` })
                                              }, null, 4)
                                            ]),
                                            _createElementVNode("span", _hoisted_43, _toDisplayString(d.cantidad === 0 ? 'Sin respuestas' : `${d.porcentaje}% (${d.cantidad})`), 1)
                                          ], 2))
                                        }), 128))
                                      ]))
                                    : (_openBlock(), _createElementBlock("p", _hoisted_44, "Aún no hay respuestas."))
                                ]))
                              }), 128))
                            : (_openBlock(), _createElementBlock("p", _hoisted_45, "No se encontraron preguntas vinculadas a este indicador."))
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_46, [
                          _cache[19] || (_cache[19] = _createElementVNode("h4", null, "Fichas Vinculadas", -1)),
                          ((fichasPorInstrumento.value[instrumento.id_instrumento!] ?? []).length)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(fichasPorInstrumento.value[instrumento.id_instrumento!], (ficha) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    key: ficha.id_ficha,
                                    class: "ficha-card"
                                  }, [
                                    _createElementVNode("div", _hoisted_48, [
                                      _createElementVNode("span", _hoisted_49, _toDisplayString(ficha.tipo), 1),
                                      _createElementVNode("span", {
                                        class: _normalizeClass(['ficha-estado', estadoClass(ficha.estado)])
                                      }, _toDisplayString(estadoTexto(ficha.estado)), 3)
                                    ]),
                                    _createElementVNode("div", _hoisted_50, [
                                      (ficha.detalle)
                                        ? (_openBlock(), _createElementBlock("p", _hoisted_51, _toDisplayString(ficha.detalle), 1))
                                        : (_openBlock(), _createElementBlock("p", _hoisted_52, "Sin detalle")),
                                      (ficha.descripcion)
                                        ? (_openBlock(), _createElementBlock("p", _hoisted_53, _toDisplayString(ficha.descripcion), 1))
                                        : _createCommentVNode("", true),
                                      (ficha.observaciones)
                                        ? (_openBlock(), _createElementBlock("p", _hoisted_54, _toDisplayString(ficha.observaciones), 1))
                                        : _createCommentVNode("", true),
                                      (ficha.origen_documento === 'cloudinary' || ficha.origen_documento === 'externo')
                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                                            _createElementVNode("a", {
                                              href: ficha.documento,
                                              target: "_blank",
                                              rel: "noopener",
                                              class: "link-doc"
                                            }, _toDisplayString(ficha.nombre_visible || 'Ver documento'), 9, _hoisted_55),
                                            (ficha.url_descarga && ficha.origen_documento === 'cloudinary')
                                              ? (_openBlock(), _createElementBlock("a", {
                                                  key: 0,
                                                  href: ficha.url_descarga,
                                                  class: "link-descargar",
                                                  title: `Descargar ${ficha.nombre_visible || 'archivo'}`
                                                }, "⬇", 8, _hoisted_56))
                                              : _createCommentVNode("", true),
                                            (ficha.origen_documento === 'externo')
                                              ? (_openBlock(), _createElementBlock("span", _hoisted_57, "externo"))
                                              : _createCommentVNode("", true),
                                            (ficha.formato)
                                              ? (_openBlock(), _createElementBlock("span", _hoisted_58, _toDisplayString(ficha.formato.toUpperCase()), 1))
                                              : _createCommentVNode("", true)
                                          ], 64))
                                        : (ficha.origen_documento === 'desconocido')
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_59, "No disponible"))
                                          : (!ficha.origen_documento && ficha.documento && ficha.documento !== 'sin-documento' && ficha.documento !== 'pendiente-upload')
                                            ? (_openBlock(), _createElementBlock("a", {
                                                key: 6,
                                                href: ficha.documento,
                                                target: "_blank",
                                                rel: "noopener",
                                                class: "link-doc"
                                              }, "Ver documento", 8, _hoisted_60))
                                            : (_openBlock(), _createElementBlock("span", _hoisted_61, "⚠ Sin documento"))
                                    ]),
                                    (ficha.calculo)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_62, [
                                          _createElementVNode("div", _hoisted_63, [
                                            _createElementVNode("span", _hoisted_64, _toDisplayString(ficha.calculo.desglose?.metodo === 'directo'
                          ? 'Cálculo por logro / meta'
                          : 'Cálculo por periodos'), 1),
                                            (ficha.calculo.nota != null)
                                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                  _createElementVNode("span", _hoisted_65, _toDisplayString(ficha.calculo.nota.toFixed(2)), 1),
                                                  _createElementVNode("button", {
                                                    type: "button",
                                                    class: "btn-usar-nota",
                                                    onClick: ($event: any) => (usarNotaDeFicha(ficha))
                                                  }, " Usar esta nota ", 8, _hoisted_66)
                                                ], 64))
                                              : _createCommentVNode("", true)
                                          ]),
                                          (ficha.calculo.nota == null)
                                            ? (_openBlock(), _createElementBlock("p", _hoisted_67, _toDisplayString(ficha.calculo.motivo), 1))
                                            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                _createElementVNode("p", _hoisted_68, [
                                                  _createTextVNode(_toDisplayString(ficha.calculo.desglose?.porcentaje_cumplimiento?.toFixed(2)) + "% de cumplimiento ", 1),
                                                  (ficha.calculo.desglose?.metodo === 'directo')
                                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                        _createTextVNode(" · logro " + _toDisplayString(ficha.calculo.desglose?.logro) + " sobre meta " + _toDisplayString(ficha.calculo.desglose?.meta), 1)
                                                      ], 64))
                                                    : _createCommentVNode("", true),
                                                  (ficha.calculo.desglose?.tendencia)
                                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                        _createTextVNode(" · " + _toDisplayString(ficha.calculo.desglose.tendencia.tendencia), 1)
                                                      ], 64))
                                                    : _createCommentVNode("", true)
                                                ]),
                                                (ficha.calculo.desglose?.periodos?.length)
                                                  ? (_openBlock(), _createElementBlock("table", _hoisted_69, [
                                                      _cache[18] || (_cache[18] = _createElementVNode("thead", null, [
                                                        _createElementVNode("tr", null, [
                                                          _createElementVNode("th", null, "Periodo"),
                                                          _createElementVNode("th", null, "Valoración"),
                                                          _createElementVNode("th", null, "Puntos")
                                                        ])
                                                      ], -1)),
                                                      _createElementVNode("tbody", null, [
                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(ficha.calculo.desglose.periodos, (p, i) => {
                                                          return (_openBlock(), _createElementBlock("tr", { key: i }, [
                                                            _createElementVNode("td", null, _toDisplayString(p.periodo), 1),
                                                            _createElementVNode("td", null, _toDisplayString(p.valoracion), 1),
                                                            _createElementVNode("td", null, _toDisplayString(p.puntos), 1)
                                                          ]))
                                                        }), 128))
                                                      ]),
                                                      (ficha.calculo.desglose?.puntaje_apreciado != null)
                                                        ? (_openBlock(), _createElementBlock("tfoot", _hoisted_70, [
                                                            _createElementVNode("tr", null, [
                                                              _createElementVNode("td", _hoisted_71, " Total sobre " + _toDisplayString(ficha.calculo.desglose.puntaje_total) + " posibles ", 1),
                                                              _createElementVNode("td", null, _toDisplayString(ficha.calculo.desglose.puntaje_apreciado), 1)
                                                            ])
                                                          ]))
                                                        : _createCommentVNode("", true)
                                                    ]))
                                                  : _createCommentVNode("", true),
                                                (ficha.calculo.desglose?.topado_al_100)
                                                  ? (_openBlock(), _createElementBlock("p", _hoisted_72, " El cumplimiento real fue " + _toDisplayString(ficha.calculo.desglose.porcentaje_sin_tope) + "%; superar la meta no da más del máximo. ", 1))
                                                  : _createCommentVNode("", true),
                                                (ficha.calculo.desglose?.valoraciones_no_reconocidas?.length)
                                                  ? (_openBlock(), _createElementBlock("p", _hoisted_73, " No se contaron: " + _toDisplayString(ficha.calculo.desglose.valoraciones_no_reconocidas.join(', ')), 1))
                                                  : _createCommentVNode("", true)
                                              ], 64))
                                        ]))
                                      : _createCommentVNode("", true)
                                  ]))
                                }), 128))
                              ]))
                            : (_openBlock(), _createElementBlock("p", _hoisted_74, "No hay fichas vinculadas a este instrumento."))
                        ]))
                  ]))
                }), 128))
              : (_openBlock(), _createElementBlock("div", _hoisted_75, _cache[20] || (_cache[20] = [
                  _createElementVNode("p", null, "Este indicador no tiene instrumentos vinculados.", -1)
                ])))
          ]))
        : _createCommentVNode("", true)
    ]),
    _cache[28] || (_cache[28] = _createElementVNode("div", { class: "divider" }, null, -1)),
    (!loading.value)
      ? (_openBlock(), _createElementBlock("form", {
          key: 2,
          class: "eval-form",
          onSubmit: _withModifiers(guardarEvaluacion, ["prevent"])
        }, [
          _cache[26] || (_cache[26] = _createElementVNode("h2", { class: "seccion-titulo" }, "Calificación Final", -1)),
          _createElementVNode("div", _hoisted_76, [
            _createElementVNode("label", null, "Nota Final (" + _toDisplayString(escalaMin.value) + " – " + _toDisplayString(escala.value) + ")", 1),
            _withDirectives(_createElementVNode("input", {
              type: "number",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((notaFinal).value = $event)),
              min: escalaMin.value,
              max: escala.value,
              step: "0.1",
              class: "form-control input-nota",
              placeholder: `Ingrese la nota (${escalaMin.value} – ${escala.value})`,
              onChange: clampNotaFinal,
              onInput: _cache[3] || (_cache[3] = ($event: any) => (notaVieneDeLaFicha.value = false))
            }, null, 40, _hoisted_77), [
              [
                _vModelText,
                notaFinal.value,
                void 0,
                { number: true }
              ]
            ]),
            (notaVieneDeLaFicha.value)
              ? (_openBlock(), _createElementBlock("p", _hoisted_78, " Tomada del cálculo de la ficha cuantitativa. Puedes dejarla o cambiarla. "))
              : _createCommentVNode("", true),
            (notaFinal.value !== null && gradoDetectado.value)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: _normalizeClass(["grado-detectado", colorSemaforo.value])
                }, [
                  _cache[22] || (_cache[22] = _createElementVNode("span", { class: "semaforo-dot" }, null, -1)),
                  _createElementVNode("span", _hoisted_79, [
                    _cache[21] || (_cache[21] = _createTextVNode("Nivel detectado: ")),
                    _createElementVNode("strong", null, _toDisplayString(gradoDetectado.value.label), 1),
                    _createTextVNode(" (" + _toDisplayString(gradoDetectado.value.rango) + "%)", 1)
                  ])
                ], 2))
              : _createCommentVNode("", true),
            (notaFinal.value !== null && !gradoDetectado.value && criteriosEvaluacion.value.length)
              ? (_openBlock(), _createElementBlock("p", _hoisted_80, " La nota ingresada no corresponde a ningún nivel de la rúbrica. "))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_81, [
            _cache[23] || (_cache[23] = _createElementVNode("label", null, [
              _createTextVNode("Observaciones "),
              _createElementVNode("span", { class: "opcional" }, "(opcional)")
            ], -1)),
            _withDirectives(_createElementVNode("textarea", {
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((form.value.observaciones) = $event)),
              class: "form-control",
              rows: "3",
              placeholder: "Análisis técnico..."
            }, null, 512), [
              [_vModelText, form.value.observaciones]
            ])
          ]),
          _createElementVNode("div", _hoisted_82, [
            _cache[24] || (_cache[24] = _createElementVNode("label", null, "Justificación *", -1)),
            _withDirectives(_createElementVNode("textarea", {
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((form.value.justificacion) = $event)),
              class: "form-control",
              rows: "3",
              placeholder: "Soporte en evidencias..."
            }, null, 512), [
              [_vModelText, form.value.justificacion]
            ])
          ]),
          _createElementVNode("div", _hoisted_83, [
            _cache[25] || (_cache[25] = _createElementVNode("label", null, "Fecha de evaluación *", -1)),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((form.value.fecha_evaluacion) = $event)),
              type: "date",
              class: "form-control",
              max: _unref(hoy)
            }, null, 8, _hoisted_84), [
              [_vModelText, form.value.fecha_evaluacion]
            ])
          ]),
          _createElementVNode("div", _hoisted_85, [
            _createElementVNode("button", {
              type: "button",
              class: "btn salir",
              onClick: _cache[7] || (_cache[7] = ($event: any) => (emit('cerrar')))
            }, "Cancelar"),
            _createElementVNode("button", {
              type: "submit",
              class: "btn guardar",
              disabled: guardando.value
            }, _toDisplayString(guardando.value ? 'Guardando...' : (esEdicion.value ? 'Actualizar Evaluación' : 'Registrar Evaluación')), 9, _hoisted_86)
          ])
        ], 32))
      : _createCommentVNode("", true),
    _createVNode(MensajeFlotante, {
      visible: mensajeVisible.value,
      mensaje: mensajeTexto.value,
      tipo: mensajeTipo.value,
      onCerrar: _cache[8] || (_cache[8] = ($event: any) => (mensajeVisible.value = false))
    }, null, 8, ["visible", "mensaje", "tipo"])
  ]))
}
}

})